import * as React from 'react';

import { formatBalance } from 'helpers/format-number';

import { TotalRewards as TotalRewardsType } from 'types/vote';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import {
    AquaLogo,
    Container,
    Description,
    PreTitle,
    Title,
    Value,
    Retry,
} from './TotalRewards.styled';

interface TotalRewardsProps {
    totalRewards: TotalRewardsType;
    error?: boolean;
    onRetry?: () => void;
}

const TotalRewards = ({ totalRewards, error, onRetry }: TotalRewardsProps): React.ReactNode => (
    <Container>
        <PreTitle>
            {error ? (
                <Retry onClick={onRetry}>Reward total unavailable. Try again</Retry>
            ) : (
                'Total daily reward:'
            )}
        </PreTitle>

        <Title>
            <AquaLogo />
            <Value
                aria-busy={!totalRewards && !error}
                aria-label={!totalRewards && !error ? 'Loading total daily reward' : undefined}
            >
                {totalRewards ? (
                    `${formatBalance(
                        totalRewards.total_daily_sdex_reward + totalRewards.total_daily_amm_reward,
                    )} AQUA`
                ) : error ? (
                    '— AQUA'
                ) : (
                    <>
                        <Bar $width="8ch" $height="0.65em" />
                        &nbsp;AQUA
                    </>
                )}
            </Value>
        </Title>
        <Description>
            Aquarius incentivizes Stellar liquidity by distributing AQUA rewards to two groups:
            liquidity providers on the Aquarius AMM, and market makers on the Stellar DEX (SDEX).
            This page shows how rewards are split across active markets.
        </Description>
    </Container>
);

export default TotalRewards;
